export const DSU_QUESTIONNAIRE_URL = "https://chestionare.mai.gov.ro/index.php/729914?lang=ro";
export const E_CONSULTATION_URL = "https://e-consultare.gov.ro/";
export const OPEN_GOVERNMENT_RESOURCES_URL = "https://sgg.gov.ro/1/resurse-utile/";
